import React from 'react'

import Team from './Team'

const Component: React.FC = () => (
  <Team title='Volunteers' />
)

export default Component